import { snapAllocationRange } from './allocationTimeSnap';

const INTEGER_FIELDS = ['buffer_before_min', 'buffer_after_min', 'sequence'];

export const toIsoString = value => {
  if (value == null) return value;
  if (value instanceof Date) return value.toISOString();
  return value;
};

export const coerceAllocationInteger = (value, fallback = 0) => {
  if (value == null || value === '') return fallback;
  if (value instanceof Date) return fallback;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.round(parsed) : fallback;
};

export const buildAllocationApiPayload = (allocationData, overrides = {}) => {
  const { timeZone, ...data } = allocationData;
  const snapped = snapAllocationRange(
    {
      start_at: data.start_at,
      end_at: data.end_at,
    },
    { timeZone: timeZone || overrides.timeZone }
  );

  const payload = {
    resource_id: data.resource_id,
    start_at: toIsoString(snapped.start_at),
    end_at: toIsoString(snapped.end_at),
  };

  const optionalFields = [
    'title',
    'description',
    'category',
    'status',
    'event_id',
    'stage',
    'metadata',
  ];

  optionalFields.forEach(field => {
    if (data[field] != null) {
      payload[field] = data[field];
    }
  });

  const bufferBefore = coerceAllocationInteger(data.buffer_before_min);
  const bufferAfter = coerceAllocationInteger(data.buffer_after_min);
  if (bufferBefore > 0) payload.buffer_before_min = bufferBefore;
  if (bufferAfter > 0) payload.buffer_after_min = bufferAfter;

  if (data.sequence != null) {
    const sequence = coerceAllocationInteger(data.sequence);
    if (sequence > 0) payload.sequence = sequence;
  }

  const safeOverrides = { ...overrides };
  delete safeOverrides.timeZone;
  return { ...payload, ...safeOverrides };
};

export const buildAllocationUpdatePayload = (
  allocationData,
  overrides = {}
) => {
  const payload = buildAllocationApiPayload(allocationData, overrides);

  INTEGER_FIELDS.forEach(field => {
    if (allocationData[field] == null && payload[field] === 0) {
      delete payload[field];
    }
  });

  return payload;
};
